import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=62cd38e1"
import script from "./UploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=62cd38e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports